import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store'
import AccessPoints from './components/AccessPoints.vue'
import AccessPointGroups from './components/AccessPointGroups.vue'
import AccessTransactionLogs from './components/AccessTransactionLogs.vue'
import AccessDevices from './components/AccessDevices.vue'
import AccessPointGroupSummary from './components/AccessPointGroupSummary.vue'
import BulkSMS from './views/BulkSMS.vue'

import Connections from './views/Connections'
import Contacts from './views/Contacts'
import ContactSummary from './views/ContactSummary'
import CustomerAccounts from './components/CustomerAccounts'
import CustomerAccountDetail from './components/CustomerAccountDetail'
import Login from './components/Login'
import Register from './components/Register'
import Vlan from './views/Vlan'
import TechnicianBulkNotifications from './components/TechnicianBulkNotifications'
import OneSignalNotifications from './views/OneSignalNotifications'
import EmailTemplates from './components/EmailTemplates'
import Promotions from './components/Promotions'
// import PackagesFnoCats from './views/PackagesFnoCats'
import PackagesFno from './views/PackagesFno'
import PackagesIsps from './views/packagesIsps'
import OwnPackagesIsps from './views/ownPackagesIsp'
import CustomerTypes from './views/CustomerTypes'
import Customers from './views/Customers.vue'
import ContactTypes from './views/ContactTypes'
import SpeedProfiles from './views/speedProfiles'
import DeviceBridges from './components/DeviceBridges'
// import DeviceMakes from './views/DeviceMakes.vue'
import DeviceSummary from './views/DeviceSummary.vue'
import DeviceSummaryNew from './views/DeviceSummaryNew.vue'
import DeviceTypes from './views/DeviceTypes'
// import DeviceMakeModels from './views/DeviceMakeModels.vue'
import Devices from './views/Devices.vue'
import FibrePlanner from './components/FibrePlanner.vue'
import FibrePlannerSettings from './components/FibrePlannerSettings.vue'
import HomeAssist from './views/HomeAssist.vue'
import Installations from './views/Installations.vue'
import ISPList from './views/ISPList.vue'
import ISPDetailView from './views/ISPDetailView.vue'

import organisationApplications from './components/organisationApplications.vue'
import organisationApplicationSummary from './components/organisationApplicationSummary.vue'
import IspOrganisation from './views/IspOrganisation.vue'
import IspOrganisationView from './views/IspOrganisationView.vue'
import locations from './views/locations'
import LocationView from './views/LocationView.vue'
import LocationNetworkId from './views/locationNetworkId'
import LocationNetworkSummaryBasic from './components/LocationNetworkBasicSummary.vue'
import LocationNetworksLocations from './components/Locations/LocationNetworksLocations'
import LocationTypes from './views/LocationTypes'
import LocationNodes from './views/LocationNode.vue'
import LocationNetwork from './views/LocationNetwork.vue'
import LocationNetworkBasic from './views/LocationNetworkBasic.vue'
import LocationNodeBasic from './views/LocationNodeBasic.vue'
import LogBook from './components/LogBook.vue'
import MassScripts from './components/MassScript.vue'
import SwitchingCentreBasic from './views/SwitchingCentreBasic.vue'
import LocationBasic from './views/LocationBasic.vue'
import LocationNetworkPackageSummary from './views/LocationNetworkPackageSummary.vue'
import GlobalPackageSummary from './components/GlobalPackageSummary.vue'
import PackageTemplate from './components/ISPPackageTemplate.vue'
import Location from './components/Locations/LocationDetail.vue'
import BasicLocation from './components/Locations/LocationBasicDetail.vue'
import OrganisationDetail from './components/OrganisationDetail.vue'
import OrganisationDetailNew from './components/OrganisationDetailNew.vue'

import ServiceAccounts from './views/ServiceAccounts.vue'
import ServiceAccountsSummary from './components/ServiceAccountSummary.vue'
import ServiceAccountsSummaryNew from './components/ServiceAccountSummaryNew.vue'

import ISPServiceAccountsSummary from './components/ISPServiceAccountSummaryNew.vue'
import Radius from './components/Radius.vue'
import ServiceAccountCards from './views/ServiceAccountCards.vue'
import ServiceLevelAgreement from './views/ServiceLevelAgreement.vue'
import ServiceLevelAgreementSummary from './views/ServiceLevelAgreementSummary.vue'
import Applications from './views/Applications.vue'
import ApplicationsNew from './views/ApplicationsNew.vue'
import ISPApplications from './views/ISPApplications.vue'
import ApplicationPageModal from './components/ApplicationPageModal.vue'
import VirtualOwnerApplications from './views/VirtualProviderApplications.vue'
import VirtualOwnerApplicationSummary from './components/VirtualOwnerApplicationSummary.vue'
import ISPServiceAccounts from './views/ISPServiceAccounts.vue'
import Layer2Billing from './views/Layer2Billing.vue'
import AccountMapping from './components/AccountContactMapping.vue'
import Vehicles from './components/Vehicles.vue'
import VirtualBilling from './components/BillingVirtualProvider.vue'
// import InvoiceTemplate from './components/InvoiceTemplate.vue'
import Billing from './views/Billing.vue'
import InfrastructureBilling from './components/InfrastructureBilling.vue'

import BillingUpdated from './components/BillingUpdated.vue'
import BillingBreakdown from './components/BillingBreakdown.vue'

import BillingHistory from './views/BillingHistory.vue'
import BillingOverview from './views/BillingOverview.vue'
import BillingDashboard from './views/BillingDashboard.vue'
import SystemInvoice from './components/SystemInvoices.vue'
import ISPDashboard from './views/ISPDashboard.vue'
import FNODashboard from './views/FNODashboard.vue'
import Cancellations from './views/Cancellations.vue'
import Api from "@/services/Api";
import refreshPermissions from "@/services/RefreshPermissions";
import Integrations from './components/Integrations.vue'
import GrapeFarmer from './components/GrapeFarmer.vue'
import GrapeFarmerNetwork from './components/GrapeFarmerNetwork.vue'
import ResellerSummary from './components/ResellerSummary.vue'
import ResellerPortal from './components/ResellerPortal.vue'
import UserPortal from './components/UserPortal.vue'
import UserPortalLogin from './components/UserPortalLogin.vue'
import UserPortalServices from './components/UserPortalServices.vue'
import UserPortalOrders from './components/UserPortalOrders.vue'

import LocationNodeId from './components/LocationNodeSummary.vue'
import SwitchingCentres from './views/SwitchingCentre.vue'
import SwitchingCentreId from './components/SwitchingCentreSummary.vue'
import CommunicationProtocols from './components/CommunicationProtocols.vue'
import TagCategories from './components/TagCategories.vue'
import Tags from './components/Tags.vue'

import ISPTickets from './components/ISPTickets.vue'
import IspFaults from './components/IspFaults.vue'
import ContractorFaults from './components/ContractorFaults.vue'
import Support from './components/Support.vue'
import Tickets from './views/Tickets.vue'
import TicketsHub from './views/TicketHub.vue'
import TicketSummary from './components/TicketSummary.vue'
import TicketSummaryNew from './components/TicketSummaryNew.vue'
import ISPTicketSummary from './components/ISPTicketSummary.vue'
import TicketCategory from './views/TicketCategories.vue'
import TicketTemplates from './components/TicketTemplates.vue'
import CannedResponses from './components/CannedResponses.vue'
import Forms from './components/Forms.vue'
import FormSummary from './components/FormSummary.vue'
import Flow from './components/Flow.vue'
import Process from './components/Process.vue'
import WorkflowProcess from './components/WorkflowProcess.vue'
import WorkflowProcessFlow from './components/WorkflowProcessFlow.vue'
import Workflow from './views/Workflow.vue'
import WorkflowSettings from './views/WorkflowSettings.vue'
import Workflows from './components/Workflows.vue'
import ProcessSummary from './components/workflow/ProcessSummary.vue'



import ContactsSummary from './components/ContactsSummary.vue'
import Access from './views/Access.vue'
import TagSummaryPage from './components/TagSummaryPage.vue'
import ApplicationSummary from './views/ApplicationSummary.vue'
import ApplicationSummaryNew from './views/ApplicationSummaryNew.vue'

import ApplicationLeadSummary from './views/ApplicationLeadSummary.vue'
import ISPApplicationSummary from './views/ISPApplicationSummary.vue'
import ISPApplicationSummaryNew from './views/ISPApplicationSummaryNew.vue'

import SplashPage from './components/SplashPage.vue'

import InventoryOrder from './views/StockOrder.vue'
import InventoryOrderItem from './views/StockOrderItem.vue'
import InventoryWarehouse from './views/StockWarehouse.vue'
import InventoryWarehouseSummary from './components/InventoryWarehouseSummary.vue'
import InventoryType from './views/StockType.vue'
import InventoryItem from './views/StockItem.vue'
import ActiveInventory from './views/ActiveInventory.vue'
import PassiveInventory from './views/PassiveInventory.vue'
import InventoryMovements from './views/InventoryMovements.vue'
import StockTake from './components/StockTake.vue'

import Task from './views/Task.vue'
import TaskTemplate from './views/TaskTemplate.vue'


// Virtual Management
import CoverageMap from './components/CoverageMap.vue'
import FNOCoverageMap from './components/fnoCoverageMap.vue'
import VirtualFNOCoverageMap from './components/virtualFnoCoverageMap.vue'
import SharedNetworks from './components/SharedFNONetwork.vue'
import VirtualFibreNetworkOperators from './components/VirtualFibreNetworkOperators.vue'
import VirtualFNONetworks from './components/VirtualFnoNetwork.vue'
import VirtualFnoPackages from './components/VirtualFnoPackages.vue'
import VirtualISP from './components/VirtualIsp.vue'
import VirtualServiceAccounts from './components/VirtualServiceAccounts.vue'
import VirtualServiceAccountSummary from './components/VirtualServiceAccountSummary.vue'
import VirtualProviderDashboard from './components/VirtualProviderDashboard.vue'
import NetworkOperators from './components/NetworkOperators'
import NetworkOperatorSummary from './components/NetworkOperatorPackages'

// User roles & permissions
import UserGroups from './views/UserGroups.vue'
import UserRoles from './views/UserRoles.vue'
import UserRoleView from './views/UserRoleView.vue'
import Organisations from './views/Organisations.vue'
import UserActivity from './components/UserActivity.vue'
import NmsSettings from './components/NmsSettings.vue'
import OrganisationTypes from './views/OrganisationTypes.vue'
import OrganisationView from './views/OrganisationView.vue'
import Modules from './views/Modules.vue'
import Submodules from './views/Submodules.vue'
import ModuleView from './views/ModuleView.vue'
import RouteMapping from './views/RouteMapping.vue'
import RouteDetail from './views/RouteDetail.vue'
import GlueAgreement from './views/GlueAgreement.vue'

import GluePricingMatrix from './views/GluePricingMatrix.vue'
import GlueBilling from './views/GlueBilling.vue'
import GlueBillingOrganisation from './views/GlueBillingOrganisation.vue'
import Region from './components/Region.vue'
import AWS from './views/awsResources.vue'
import MicroServiceMonitoring from './views/MicroServiceMonitoring.vue'
import Scripts from './views/Scripts.vue'


Vue.use(Router)

let isAuthenticated = false
const authenticateToken = async function(req, res, next) {
    await Api()
        .get('/authenticate')
        .then(response => {
            next()
        }).catch(error => {
            next({
                name: 'Login'
            })
        })
}
const authenticateUser = async function(req, res, next) {
    await Api()
        .get('/authenticate/email/' +
            store.state.user.emailAddress
        )
        .then(response => {
            console.log(response.status)
            if (response.status === 200) {
                next()
            } else {
                next({
                    name: 'SplashPage'
                })
            }

        }).catch(error => {
            next({
                name: 'SplashPage'
            })
        })
}
const authenticateOrgAdmin = async function(req, res, next) {
    await Api()
        .get('/authenticate/admin/' +
            store.state.user.emailAddress + '/' + store.state.user.id
        )
        .then(response => {
            if (response.data.auth === true) {
                next()
            } else {
                next({
                    name: 'SplashPage'
                })
            }

        }).catch(error => {
            next({
                name: 'SplashPage'
            })
        })
}

async function setRoute(route, next) {
    let findRoute = await store.state.currentOrg.org.permissions.find(x => x.url === route)
    if (findRoute) {
        await store.dispatch("setCurrentRoute", findRoute);
        next()
    } else {
        next({
            name: 'SplashPage'
        })
    }
}
async function setUserPortalRoute(route, next) {

    await store.dispatch("setCurrentRoute", route);
    next()

}



const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
            path: '/',
            name: 'Home',
            component: Login
        },
        {
            path: '/unauthorised',
            name: 'SplashPage',
            component: SplashPage,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
            }
        },
        // {
        //     path: '/StreamData',
        //     name: 'StreamData',
        //     component: StreamData,
        //     beforeEnter: (req, res, next) => {
        //         authenticateToken(req, res, next)
        //     }
        // },
        {
            path: '/grapeFarmer',
            name: 'GrapeFarmer',
            component: GrapeFarmer,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/grapeFarmer', next)
            }
        },

        {
            path: '/xeroAccountMapping',
            name: 'AccountMapping',
            component: AccountMapping,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/xeroAccountMapping', next)
            }
        },
        // {
        //     path: '/invoiceTemplates',
        //     name: 'InvoiceTemplate',
        //     component: InvoiceTemplate,
        //     beforeEnter: (req, res, next) => {
        //         authenticateToken(req, res, next)
        //         setRoute('/invoiceTemplates', next)
        //     }
        // },
        {
            path: '/applications',
            name: 'Applications',
            // component: Applications,
            component: ApplicationsNew,

            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/applications', next)
            }
        },
        {
            path: '/applications/:applicationId',
            name: 'ApplicationSummary',
            component: ApplicationSummaryNew,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/applications/:applicationId', next)
            }
        },
        {
            path: '/applications/lead/:applicationId',
            name: 'ApplicationLeadSummary',
            component: ApplicationLeadSummary,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/applications/lead/:applicationId', next)
            }
        },
        {
            path: '/bulkSMS',
            name: 'BulkSMS',
            component: BulkSMS,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/bulkSMS', next)
            }
        },
        {
            path: '/ispApplications',
            name: 'ISPApplications',
            component: ISPApplications,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/ispApplications', next)

            }
        },
        {
            path: '/logBook',
            name: 'LogBook',
            component: LogBook,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/logBook', next)
            }
        },
        {
            path: '/vehicles',
            name: 'Vehicles',
            component: Vehicles,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/vehicles', next)
            }
        },
        {
            path: '/applicationPageModal',
            name: 'ApplicationPageModal',
            component: ApplicationPageModal,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/applicationPageModal', next)

            }
        },
        {
            path: '/virtualOwnerApplications',
            name: 'VirtualOwnerApplications',
            component: VirtualOwnerApplications,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/virtualOwnerApplications', next)

            }
        },
        {
            path: '/virtualOwnerApplication/:applicationId',
            name: 'VirtualOwnerApplicationSummary',
            component: VirtualOwnerApplicationSummary,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/virtualOwnerApplication/:applicationId', next)
            }
        },
        {
            path: '/ispApplications/:applicationId',
            name: 'ISPApplicationSummary',
            component: ISPApplicationSummaryNew,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/ispApplications/:applicationId', next)
            }
        },
        {
            path: '/billing',
            name: 'All Billing',
            // component: Billing,
            component: BillingUpdated,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/billing', next)
            }
        },
        {
            path: '/infrastructureBilling',
            name: 'Infrastructure Billing',
            // component: Billing,
            component: InfrastructureBilling,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/infrastructureBilling', next)
            }
        },
        {
            path: '/billingBreakdown/:id',
            name: 'Billing Breakdown',
            // component: Billing,
            component: BillingBreakdown,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/billingBreakdown/:id', next)
            }
        },
        {
            path: '/virtualProviderBilling',
            name: 'Virtual Billing',
            component: VirtualBilling,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/virtualProviderBilling', next)
            }
        },
        {
            path: '/layer2Billing',
            name: 'layer2Billing',
            component: Layer2Billing,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/layer2Biling', next)
                    // if(!store.state.currentOrg.org.frontendRoutes.includes(req.path)){
                    //     next({ name: 'SplashPage' })
                    //   }
            }
        },
        {
            path: '/billingHistory',
            name: 'Billing History',
            component: BillingHistory,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/billingHistory', next)
            }
        },
        {
            path: '/billingOverview',
            name: 'Billing Overview',
            component: BillingOverview,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/billingOverview', next)
            }
        },
        {
            path: '/billingDashboard',
            name: 'Billing Dashboard',
            component: BillingDashboard,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/billingDashboard', next)
            }
        },
        {
            path: '/ispList',
            name: 'ISP List',
            component: ISPList,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/ispList', next)
            }
        },
        {
            path: '/ispList/:customerOrganisationId',
            name: 'ISP Detail View',
            component: ISPDetailView,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/ispList/:customerOrganisationId', next)
            }
        },
        {
            path: '/systemInvoice',
            name: 'SystemInvoice',
            component: SystemInvoice,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/systemInvoice', next)
            }
        },
        {
            path: '/serviceAccounts',
            name: 'ServiceAccounts',
            component: ServiceAccounts,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/serviceAccounts', next)
            }
        },
        {
            path: '/serviceAccounts/:serviceAccountId',
            name: 'ServiceAccountsSummary',
            component: ServiceAccountsSummaryNew,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/serviceAccounts/:serviceAccountId', next)
            }
        },
        {
            path: '/isp/serviceAccounts/:serviceAccountId',
            name: 'ISPServiceAccountsSummary',
            component: ISPServiceAccountsSummary,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/isp/serviceAccounts/:serviceAccountId', next)
            }
        },
        {
            path: '/ServiceAccountCards',
            name: 'ServiceAccountCards',
            component: ServiceAccountCards,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                if (!store.state.currentOrg.org.frontendRoutes.includes('/ServiceAccountCards')) {
                    next({
                        name: 'SplashPage'
                    })
                }
            }
        },
        {
            path: '/locationNetwork',
            name: 'LocationNetwork',
            component: LocationNetwork,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/locationNetwork', next)
            }
        },
        {
            path: '/locationNetworkBasic',
            name: 'LocationNetworkBasic',
            component: LocationNetworkBasic,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/locationNetworkBasic', next)
            }
        },
        {
            path: '/locationNodeBasic',
            name: 'LocationNodeBasic',
            component: LocationNodeBasic,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/locationNodeBasic', next)
            }
        },
        {

            path: '/massScripts',
            name: 'MassScripts',
            component: MassScripts,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/massScripts', next)
            }
        },
        {
            path: '/locationBasic',
            name: 'LocationBasic',
            component: LocationBasic,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/locationBasic', next)
            }
        },
        {
            path: '/switchingCentreBasic',
            name: 'SwitchingCentreBasic',
            component: SwitchingCentreBasic,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/switchingCentreBasic', next)
            }
        },
        {
            path: '/mobileBulkNotifications',
            name: 'OneSignalNotifications',
            component: OneSignalNotifications,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/mobileBulkNotifications', next)
            }
        },
        {
            path: '/technicianBulkNotifications',
            name: 'TechnicianBulkNotifications',
            component: TechnicianBulkNotifications,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/technicianBulkNotifications', next)
            }
        },
        {
            path: '/emailNotifications',
            name: 'EmailTemplates',
            component: EmailTemplates,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/emailNotifications', next)
            }
        },
        {
            path: '/promotions',
            name: 'Promotions',
            component: Promotions,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/promotions', next)
            }
        },
        {
            path: '/devices',
            name: 'Devices',
            component: Devices,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/devices', next)
            }
        },
        {
            path: '/devices/:deviceId',
            name: 'DeviceSummary',
            component: DeviceSummaryNew,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/devices/:deviceId', next)
            }
        },
        {
            path: '/fibrePlanner',
            name: 'FibrePlanner',
            component: FibrePlanner,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/fibrePlanner', next)
            }
        },
        {
            path: '/fibrePlannerSettings',
            name: 'FibrePlannerSettings',
            component: FibrePlannerSettings,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/fibrePlannerSettings', next)
            }
        },
        {
            path: '/homeAssist',
            name: 'HomeAssist',
            component: HomeAssist,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/homeAssist', next)
            }
        },
        {
            path: '/locationNodes',
            name: 'LocationNodes',
            component: LocationNodes,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/locationNodes', next)
            }
        },
        {
            path: '/locations',
            name: 'Locations',
            component: LocationView,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/locations', next)
            }
        },
        {
            path: '/locationTypes',
            name: 'LocationTypes',
            component: LocationTypes,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/locationTypes', next)
            }
        },
        {
            path: '/switchingCentres',
            name: 'SwitchingCentres',
            component: SwitchingCentres,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/switchingCentres', next)
            }
        },
        {
            path: '/switchingCentres/:switchingCentreId',
            name: 'SwitchingCentreId',
            component: SwitchingCentreId,
            props: true,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/switchingCentres/:switchingCentreId', next)
            }
        },
        // {
        //     path: '/packageFnoCats',
        //     name: 'PackagesFnoCats',
        //     component: PackagesFnoCats,
        //     props: true,
        //     beforeEnter: (req, res, next) => {
        //         authenticateToken(req, res, next)
        //         setRoute('/packageFnoCats', next)
        //     }
        // },
        {
            path: '/packagesFno',
            name: 'PackagesFno',
            component: PackagesFno,
            props: true,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/packagesFno', next)
            }
        },
        {
            path: '/contacts',
            name: 'Contacts',
            component: Contacts,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/contacts', next)
            }
        },
        {
            path: '/networkOperators',
            name: 'NetworkOperators',
            component: NetworkOperators,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/networkOperators', next)
            }
        },
        {
            path: '/networkOperators/:networkOperatorId',
            name: 'NetworkOperatorSummary',
            component: NetworkOperatorSummary,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/networkOperators/:networkOperatorId', next)
            }
        },

        {
            path: '/contacts/:contactId',
            name: 'ContactSummary',
            component: ContactSummary,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/contacts/:contactId', next)
            }
        },
        {
            path: '/customerAccounts',
            name: 'CustomerAccounts',
            component: CustomerAccounts,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/customerAccounts', next)
            }
        },
        {
            path: '/customerAccount/:customerAccountId',
            name: 'CustomerAccountDetail',
            component: CustomerAccountDetail,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/customerAccount/:customerAccountId', next)
            }
        },

        {
            path: '/packagesIsps',
            name: 'PackagesIsps',
            component: PackagesIsps,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/packagesIsps', next)
            }
        },
        {
            path: '/packagesIsps/suppliers/:supplierId',
            name: 'OwnPackagesIsps',
            component: OwnPackagesIsps,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/packagesIsps/suppliers/:supplierId', next)
            }
        },
        {
            path: '/contactTypes',
            name: 'ContactTypes',
            component: ContactTypes,
            props: true,
            beforeEnter: (req, res, next) => {
                if (!authenticateUser(req, res, next)) {
                    next({
                        name: 'SplashPage'
                    })
                }
            }
        },
        {
            path: '/customerTypes',
            name: 'CustomerTypes',
            component: CustomerTypes,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                authenticateOrgAdmin(req, res, next)
                if (!store.state.currentOrg.org.frontendRoutes.includes('/customerTypes')) {
                    next({
                        name: 'SplashPage'
                    })
                }
            }
        },
        {
            path: '/customers',
            name: 'Customers',
            component: Customers,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                if (!store.state.currentOrg.org.frontendRoutes.includes('/customers')) {
                    next({
                        name: 'SplashPage'
                    })
                }
            }
        },

        {
            path: '/packageTemplate',
            name: 'PackageTemplate',
            component: PackageTemplate,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/packageTemplate', next)
            }
        },
        {
            path: '/speedProfiles',
            name: 'SpeedProfiles',
            component: SpeedProfiles,
            beforeEnter: (req, res, next) => {
                if (!authenticateUser(req, res, next)) {
                    next({
                        name: 'SplashPage'
                    })
                }
            }
        },
        {
            path: '/deviceConnections',
            name: 'DeviceBridges',
            component: DeviceBridges,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/deviceConnections', next)
            }
        },
        // {
        //     path: '/deviceMakes',
        //     name: 'DeviceMakes',
        //     component: DeviceMakes,
        //     beforeEnter: (req, res, next) => {
        //         authenticateToken(req, res, next)
        //         setRoute('/deviceMakes', next)
        //     }
        // },
        {
            path: '/deviceTypes',
            name: 'DeviceTypes',
            component: DeviceTypes,
            beforeEnter: (req, res, next) => {
                if (!authenticateUser(req, res, next)) {
                    next({
                        name: 'SplashPage'
                    })
                }
            }
        },
        // {
        //     path: '/deviceMakeModels',
        //     name: 'DeviceMakeModels',
        //     component: DeviceMakeModels,
        //     beforeEnter: (req, res, next) => {
        //         authenticateToken(req, res, next)
        //         setRoute('/deviceMakeModels', next)
        //     }
        // },
        {
            path: '/installations',
            name: 'Installations',
            component: Installations,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/installations', next)
            }
        },
        {
            path: '/organisationApplications',
            name: 'organisationApplications',
            component: organisationApplications,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/organisationApplications', next)
            }
        },
        {
            path: '/organisationApplications/:organisationApplicationId',
            name: 'organisationApplicationSummary',
            component: organisationApplicationSummary,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/organisationApplications/:organisationApplicationId', next)
            }
        },
        {
            path: '/vlans',
            name: 'Vlans',
            component: Vlan,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/vlans', next)
            }
        },
        {
            path: '/inventory/orders',
            name: 'InventoryOrder',
            component: InventoryOrder,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/inventory/orders', next)
            }
        },
        {
            path: '/inventory/orders/:orderId',
            name: 'InventoryOrderItem',
            component: InventoryOrderItem,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/inventory/orders/:orderId', next)
            }
        },
        {
            path: '/inventory/inventoryTypes',
            name: 'InventoryType',
            component: InventoryType,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/inventory/inventoryTypes', next)
            }
        },
        {
            path: '/inventory/warehouse',
            name: 'InventoryWarehouse',
            component: InventoryWarehouse,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/inventory/warehouse', next)
            }
        },
        {
            path: '/inventoryWarehouseSummary/:inventoryWarehouseId',
            name: 'InventoryWarehouseSummary',
            component: InventoryWarehouseSummary,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/inventoryWarehouseSummary/:inventoryWarehouseId', next)
            }
        },
        {
            path: '/inventory/inventoryItems',
            name: 'InventoryItem',
            component: InventoryItem,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/inventory/inventoryItems', next)
            }
        },
        {
            path: '/inventory/activeInventory',
            name: 'ActiveInventory',
            component: ActiveInventory,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/inventory/activeInventory', next)
            }
        },
        {
            path: '/inventory/passiveInventory',
            name: 'PassiveInventory',
            component: PassiveInventory,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/inventory/passiveInventory', next)
            }
        },
        {
            path: '/inventoryMovements',
            name: 'InventoryMovements',
            component: InventoryMovements,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/inventoryMovements', next)
            }
        },
        {
            path: '/stockTake',
            name: 'StockTake',
            component: StockTake,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/stockTake', next)
            }
        },
        {
            path: '/tasks',
            name: 'Task',
            component: Task,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/tasks', next)
            }
        },
        {
            path: '/tasktemplate',
            name: 'TaskTemplate',
            component: TaskTemplate,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/tasks', next)
            }
        },
        {
            path: '/support',
            name: 'Support',
            component: Support,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/support', next)
            }
        },
        {
            path: '/ispFaults',
            name: 'IspFaults',
            component: IspFaults,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/ispFaults', next)
            }
        },
        {
            path: '/ispFaultQueue',
            name: 'IspFaultQueue',
            component: IspFaults,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/ispFaultQueue', next)
            }
        },
        {
            path: '/contractorFaults',
            name: 'ContractorFaults',
            component: ContractorFaults,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/contractorFaults', next)
            }
        },
        {
            path: '/ispTickets',
            name: 'ISPTickets',
            component: ISPTickets,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/ispTickets', next)
            }
        },
        {
            path: '/tickets',
            name: 'Tickets',
            component: TicketsHub,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/tickets', next)
            }
        },
        {
            path: '/ticketSummary/:ticketId',
            name: 'TicketSummary',
            props: true,
            component: TicketSummaryNew,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/ticketSummary/:ticketId', next)
            }
        },
        {
            path: '/ispTicketSummary/:ticketId',
            name: 'ISPTicketSummary',
            props: true,
            component: ISPTicketSummary,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/ispTicketSummary/:ticketId', next)
            }
        },
        {
            path: '/ticketCategory',
            name: 'TicketCategory',
            component: TicketCategory,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/ticketCategory', next)
            }
        },
        {
            path: '/ticketTemplates',
            name: 'ticketTemplates',
            component: TicketTemplates,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/ticketTemplates', next)
            }
        },
        {
            path: '/workflows/processes/:processId',
            name: 'Process',
            component: Process
                // beforeEnter: (req, res, next) => {
                //     authenticateToken(req, res, next)
                //     setRoute('/processs', next)
                // }
        },
        {
            path: '/workflows/subflows',
            name: 'WorkflowProcess',
            component: WorkflowProcess,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/workflows/subflows', next)
            }
        },
        {
            path: '/workflows/flows',
            name: 'WorkflowProcessFlow',
            component: Workflow,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/workflows/flows', next)
            }
        },
        {
            path: '/process/:id',
            name: 'ProcessSummary',
            component: ProcessSummary,
            // beforeEnter: (req, res, next) => {
            //     authenticateToken(req, res, next)
            //     setRoute('/process/:id', next)
            // }
        },
        
        {
            path: '/workflows/flows/:flowId',
            name: 'Flow',
            component: Flow
                // beforeEnter: (req, res, next) => {
                //     authenticateToken(req, res, next)
                //     setRoute('/processs', next)
                // }
        },

        {
            path: '/workflowSettings',
            name: 'WorkflowSettings',
            component: WorkflowSettings,
            beforeEnter: (req, res, next) => {
                if (!authenticateUser(req, res, next)) {
                    next({
                        name: 'SplashPage'
                    })
                }
            }
        },
        {
            path: '/workflows',
            name: 'Workflows',
            component: Workflows,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/workflows', next)
            }
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
            beforeEnter: (req, res, next) => {
                next(store.dispatch("setToken", null),
                    store.dispatch("setUser", null),
                    store.dispatch("setPermission", null),
                    store.dispatch("setCustomerId", null),
                    store.dispatch("setIsUserLoggedIn", false))
            }
        },
        {
            path: '/register',
            name: 'Register',
            component: Register
        },
        {
            path: '/locationNetworks/:locationNetworkId',
            name: 'LocationNetworkId',
            component: LocationNetworkId,
            props: true,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/locationNetworks/:locationNetworkId', next)
            }
        },
        {
            path: '/locationNetworks/basic/:locationNetworkId',
            name: 'LocationNetworkSummaryBasic',
            component: LocationNetworkSummaryBasic,
            props: true,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/locationNetworks/basic/:locationNetworkId', next)
            }
        },
        {
            path: '/locationNodes/:locationNodeId',
            name: 'LocationNodeId',
            component: LocationNodeId,
            props: true,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/locationNodes/:locationNodeId', next)
            }
        },
        {
            path: '/locationNetworks/:locationNetworkId/locations',
            name: 'LocationNetworksLocations',
            component: LocationNetworksLocations,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/locationNetworks/:locationNetworkId', next)
            }
        },
        {
            path: '/locationNetworks/:locationNetworkId/:locationId',
            name: 'Location',
            component: Location,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/locationNetworks/:locationNetworkId/:locationId', next)
            }
        },
        {
            path: '/locationNetworks/basic/:locationNetworkId/:locationId',
            name: 'BasicLocation',
            component: BasicLocation,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/locationNetworks/basic/:locationNetworkId/:locationId', next)
            }
        },
        {
            path: '/packageSummary/:locationNetworkId',
            name: 'LocationNetworkPackageSummary',
            component: LocationNetworkPackageSummary,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/packageSummary/:locationNetworkId', next)
            }
        },
        {
            path: '/globalPackageSummary/:packagesIspId',
            name: 'GlobalPackageSummary',
            component: GlobalPackageSummary,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/globalPackageSummary/:packagesIspId', next)
            }
        },
        {
            path: '/organisationDetail',
            name: 'OrganisationDetail',
            component: OrganisationDetailNew,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                authenticateOrgAdmin(req, res, next)
            }
        },
        {
            path: '/grapeFarmer/network/:locationNetworkId',
            name: 'GrapeFarmerNetwork',
            component: GrapeFarmerNetwork,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/grapeFarmer/network/:locationNetworkId', next)
            }
        },
        {
            path: '/reseller/network/:locationNetworkId',
            name: 'ResellerSummary',
            component: ResellerSummary,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/reseller/network/:locationNetworkId', next)
            }
        },
        {
            path: '/resellerPortal',
            name: 'ResellerPortal',
            component: ResellerPortal,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/resellerPortal', next)
            }
        },
        {
            path: '/userPortal/dashboard',
            name: 'UserPortal',
            component: UserPortal,
            beforeEnter: (req, res, next) => {
                setUserPortalRoute('/userPortal/dashboard', next)
            }
        },
        {
            path: '/userPortal/login',
            name: 'UserPortalLogin',
            component: UserPortalLogin
        },
        {
            path: '/userPortal/login/:organisationId',
            name: 'UserPortalLoginOrganisation',
            component: UserPortalLogin
        },
        {
            path: '/userPortal/services',
            name: 'UserPortalServices',
            component: UserPortalServices,
            beforeEnter: (req, res, next) => {
                setUserPortalRoute('/userPortal/services', next)
            }
        },
        {
            path: '/userPortal/orders',
            name: 'UserPortalOrders',
            component: UserPortalOrders,
            beforeEnter: (req, res, next) => {
                setUserPortalRoute('/userPortal/orders', next)
            }
        },
        {
            path: '/ispServiceAccounts',
            name: 'ISPServiceAccounts',
            component: ISPServiceAccounts,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/ispServiceAccounts', next)
                if (!store.state.currentOrg.org.frontendRoutes.includes('/ispServiceAccounts')) {
                    next({
                        name: 'SplashPage'
                    })
                }
            }
        },
        {
            path: '/radius',
            name: 'Radius',
            component: Radius,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/radius', next)
            }
        },
        {
            path: '/serviceLevelAgreement',
            name: 'ServiceLevelAgreement',
            component: ServiceLevelAgreement,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/serviceLevelAgreement', next)
            }
        },
        {
            path: '/serviceLevelAgreement/:serviceLevelAgreementId',
            name: 'ServiceLevelAgreementSummary',
            component: ServiceLevelAgreementSummary,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/serviceLevelAgreement/:serviceLevelAgreementId', next)
            }
        },
        {
            path: '/cannedResponses',
            name: 'CannedResponses',
            component: CannedResponses,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/cannedResponses', next)
            }
        },
        {
            path: '/forms',
            name: 'Forms',
            component: Forms,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/forms', next)
            }
        },
        {
            path: '/forms/:id',
            name: 'FormSummary',
            component: FormSummary,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/forms/:id', next)
            }
        },
        {
            path: '/ispDashboard',
            name: 'IspDashboard',
            component: ISPDashboard,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/ispApplications', next)
            }
        },
        {
            path: '/fnoDashboard',
            name: 'fnoDashboard',
            component: FNODashboard,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/fnoDashboard', next)
            }
        },
        {
            path: '/cancellations',
            name: 'Cancellations',
            component: Cancellations,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/cancellations', next)
            }
        },
        {
            path: '/integrations',
            name: 'Integrations',
            component: Integrations,
            props: true,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                authenticateOrgAdmin(req, res, next)
            }
        },
        {
            path: '/communicationProtocols',
            name: 'CommunicationProtocols',
            component: CommunicationProtocols,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
            }
        },
        {
            path: '/tagCategories',
            name: 'TagCategories',
            component: TagCategories,
            props: true,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
            }
        },
        {
            path: '/tags',
            name: 'Tags',
            component: Tags,
            props: true,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
            }
        },
        {
            path: '/access',
            name: 'Access',
            component: Access,
            props: true,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
            }
        },
        {
            path: '/accessPoints',
            name: 'AccessPoints',
            component: AccessPoints,
            props: true,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
            }
        },
        {
            path: '/accessPointGroups',
            name: 'AccessPointGroups',
            component: AccessPointGroups,
            props: true,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
            }
        },
        {
            path: '/accessTransactionLogs',
            name: 'AccessTransactionLogs',
            component: AccessTransactionLogs,
            props: true,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
            }
        },
        {
            path: '/accessDevices',
            name: 'AccessDevices',
            component: AccessDevices,
            props: true,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
            }
        },
        {
            path: '/accessPointGroupSummary/:accessPointGroupId',
            name: 'AccessPointGroupSummary',
            component: AccessPointGroupSummary,
            props: true,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
            }
        },
        {
            path: '/connections',
            name: 'Connections',
            component: Connections,
            props: true,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                authenticateOrgAdmin(req, res, next)
                if (!store.state.currentOrg.org.frontendRoutes.includes(req.path)) {
                    next({
                        name: 'SplashPage'
                    })
                }
            }
        },

        {
            path: '/contactSummary/:contactId',
            name: 'ContactsSummary',
            component: ContactsSummary,
            props: true,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/contactSummary/:contactId', next)
            }
        },
        {
            path: '/tagSummaryPage/:tagId',
            name: 'TagSummaryPage',
            component: TagSummaryPage,
            props: true,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
            }
        },
        // User Roles & Permissions UserGroups

        {
            path: '/userGroups',
            name: 'UserGroups',
            component: UserGroups,
            props: true,
            beforeEnter: (req, res, next) => {
                if (!authenticateUser(req, res, next)) {
                    next({
                        name: 'SplashPage'
                    })
                }
                // if(!store.state.currentOrg.org.frontendRoutes.includes('/userGroups')){
                //     next({ name: 'SplashPage' })
                //   }
            }
        },
        {
            path: '/userRoles',
            name: 'UserRoles',
            component: UserRoles,
            props: true,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                authenticateOrgAdmin(req, res, next)
                if (!store.state.currentOrg.org.frontendRoutes.includes(req.path)) {
                    next({
                        name: 'SplashPage'
                    })
                } else if (store.state.currentOrg.org.frontendRoutes.includes('/userRoles')) {
                    setRoute('/userRoles', next)
                }
            }
        },
        {
            path: '/userRoles/:userRoleId',
            name: 'UserRoleView',
            component: UserRoleView,
            props: true,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                authenticateOrgAdmin(req, res, next)
                if (store.state.currentOrg.org.frontendRoutes.includes('/userRoles/:userRoleId')) {
                    setRoute('/userRoles/:userRoleId', next)
                }
            }
        },
        {
            path: '/organisations',
            name: 'Organisations',
            component: Organisations,
            props: true,
            beforeEnter: (req, res, next) => {
                if (!authenticateUser(req, res, next)) {
                    next({
                        name: 'SplashPage'
                    })
                }
            }
        },
        {
            path: '/userActivity',
            name: 'UserActivity',
            component: UserActivity,
            beforeEnter: (req, res, next) => {
                if (!authenticateUser(req, res, next)) {
                    next({
                        name: 'SplashPage'
                    })
                }
            }
        },
        {
            path: '/nmsSettings',
            name: 'NmsSettings',
            component: NmsSettings,
            beforeEnter: (req, res, next) => {
                if (!authenticateUser(req, res, next)) {
                    next({
                        name: 'SplashPage'
                    })
                }
            }
        },
        {
            path: '/organisation/isp',
            name: 'IspOrganisation',
            component: IspOrganisation,
            props: true,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                authenticateOrgAdmin(req, res, next)
                if (store.state.currentOrg.org.frontendRoutes.includes('/organisation/isp')) {
                    setRoute('/organisation/isp', next)
                }
            }
        },
        {
            path: '/organisation/isp/:organisationId',
            name: 'IspOrganisationView',
            component: IspOrganisationView,
            props: true,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                authenticateOrgAdmin(req, res, next)
                if (store.state.currentOrg.org.frontendRoutes.includes('/organisation/isp/:organisationId')) {
                    setRoute('/organisation/isp/:organisationId', next)
                }
            }
        },
        {
            path: '/organisationTypes',
            name: 'OrganisationTypes',
            component: OrganisationTypes,
            props: true,
            beforeEnter: (req, res, next) => {
                if (!authenticateUser(req, res, next)) {
                    next({
                        name: 'SplashPage'
                    })
                }
            }
        },
        {
            path: '/organisations/:organisationId',
            name: 'OrganisationView',
            component: OrganisationView,
            props: true,
            beforeEnter: (req, res, next) => {
                // authenticateOrgAdmin(req, res, next)
                if (!authenticateUser(req, res, next)) {
                    next({
                        name: 'SplashPage'
                    })
                }
            }
        },
        {
            path: '/modules',
            name: 'Modules',
            component: Modules,
            props: true,
            beforeEnter: (req, res, next) => {
                if (!authenticateUser(req, res, next)) {
                    next({
                        name: 'SplashPage'
                    })
                }
            }
        },
        {
            path: '/submodules',
            name: 'Submodules',
            component: Submodules,
            props: true,
            beforeEnter: (req, res, next) => {
                if (!authenticateUser(req, res, next)) {
                    next({
                        name: 'SplashPage'
                    })
                }
            }
        },
        {
            path: '/modules/:moduleId',
            name: 'ModuleView',
            component: ModuleView,
            props: true,
            beforeEnter: (req, res, next) => {
                if (!authenticateUser(req, res, next)) {
                    next({
                        name: 'SplashPage'
                    })
                }
            }
        },
        {
            path: '/routeMapping',
            name: 'RouteMapping',
            component: RouteMapping,
            props: true,
            beforeEnter: (req, res, next) => {
                if (!authenticateUser(req, res, next)) {
                    next({
                        name: 'SplashPage'
                    })
                }
            }
        },
        {
            path: '/routeMapping/:frontendRouteId',
            name: 'RouteDetail',
            component: RouteDetail,
            props: true,
            beforeEnter: (req, res, next) => {
                if (!authenticateUser(req, res, next)) {
                    next({
                        name: 'SplashPage'
                    })
                }
            }
        },
        {
            path: '/glueAgreements',
            name: 'GlueAgreement',
            component: GlueAgreement,
            props: true,
            beforeEnter: (req, res, next) => {
                if (!authenticateUser(req, res, next)) {
                    next({
                        name: 'SplashPage'
                    })
                }
            }
        },
        {
            path: '/glueBilling',
            name: 'GluePricingMatrix',
            // component: GluePricingMatrix,
            component: GlueBilling,

            props: true,
            beforeEnter: (req, res, next) => {
                if (!authenticateUser(req, res, next)) {
                    next({
                        name: 'SplashPage'
                    })
                }
            }
        },
        {
            path: '/glueBilling/:organisationId',
            name: 'GlueBillingOrganisation',
            // component: GluePricingMatrix,
            component: GlueBillingOrganisation,

            props: true,
            beforeEnter: (req, res, next) => {
                if (!authenticateUser(req, res, next)) {
                    next({
                        name: 'SplashPage'
                    })
                }
            }
        },
        {
            path: '/virtualFibreNetworkOperators',
            name: 'VirtualFibreNetworkOperators',
            component: VirtualFibreNetworkOperators,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/virtualFibreNetworkOperators', next)
            }
        },
        {
            path: '/virtualFnoNetworks',
            name: 'VirtualFNONetworks',
            component: VirtualFNONetworks,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/virtualFnoNetworks', next)
            }
        },
        {
            path: '/virtualFnoPackages',
            name: 'VirtualFnoPackages',
            component: VirtualFnoPackages,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/virtualFnoPackages', next)
            }
        },


        {
            path: '/virtualIsp',
            name: 'VirtualISP',
            component: VirtualISP,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/virtualIsp', next)
            }
        },

        {
            path: '/virtualServiceAccounts',
            name: 'VirtualServiceAccounts',
            component: VirtualServiceAccounts,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/virtualServiceAccounts', next)
            }
        },
        {
            path: '/virtualServiceAccount/:serviceAccountId',
            name: 'VirtualServiceAccountSummary',
            component: VirtualServiceAccountSummary,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/virtualServiceAccount/:serviceAccountId', next)
            }
        },
        {
            path: '/virtualProviderDashboard',
            name: 'VirtualProviderDashboard',
            component: VirtualProviderDashboard,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/virtualProviderDashboard', next)
            }
        },
        {
            path: '/coverageMap',
            name: 'CoverageMap',
            component: CoverageMap,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/coverageMap', next)
            }
        },
        {
            path: '/fnoCoverageMap',
            name: 'FNOCoverageMap',
            component: FNOCoverageMap,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/fnoCoverageMap', next)
            }
        },
        {
            path: '/virtualFNOCoverageMap',
            name: 'VirtualFNOCoverageMap',
            component: VirtualFNOCoverageMap,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/virtualFNOCoverageMap', next)
            }
        },
        {
            path: '/sharedNetworks',
            name: 'SharedNetworks',
            component: SharedNetworks,
            beforeEnter: (req, res, next) => {
                authenticateToken(req, res, next)
                setRoute('/sharedNetworks', next)
            }
        },
        {
            path: '/regions',
            name: 'Region',
            component: Region,
            props: true,
            beforeEnter: (req, res, next) => {
                if (!authenticateUser(req, res, next)) {
                    next({
                        name: 'SplashPage'
                    })
                }
            }
        },
        {
            path: '/awsMonitoring',
            name: 'AWS',
            component: AWS,
            props: true,
            beforeEnter: (req, res, next) => {
                if (!authenticateUser(req, res, next)) {
                    next({
                        name: 'SplashPage'
                    })
                }
            }
        },
        {
            path: '/microServiceMonitoring',
            name: 'MicroServiceMonitoring',
            component: MicroServiceMonitoring,
            props: true,
            beforeEnter: (req, res, next) => {
                if (!authenticateUser(req, res, next)) {
                    next({
                        name: 'SplashPage'
                    })
                }
            }
        },
        {
            path: '/scripts',
            name: 'Scripts',
            component: Scripts,
            props: true,
            beforeEnter: (req, res, next) => {
                if (!authenticateUser(req, res, next)) {
                    next({
                        name: 'SplashPage'
                    })
                }
            }
        },

    ]
})

// Pick up role and organisation changes made since the user last logged in
// (services/RefreshPermissions.js) before the page guards read them.
router.beforeEach(async (to, from, next) => {
    if (to.name !== 'Login' && to.name !== 'Home') {
        await refreshPermissions()
    }
    next()
})

export default router
